'use strict';
module.exports = Backbone.Model.extend({
    acceptsNewsletter: null,
    recaptchaWidgetID: null,
    recaptchaCallbackData: null,
    recaptchaRendered: false,
    errors: {
        'STA_001': 'emailExist-',
        'STA_006': 'emailExist-facebook',
        'STA_007': 'emailExist-google',
        'STA_008': 'emailExist-social',
        'AUTH_000': 'tokenError',
        'AUTH_002': 'permissions',
        'AUTH_005': 'authErrorFacebook',
        'AUTH_006': 'authErrorGoogle',
        'AUTH_008': 'socialError',
        'AUTH_010': 'tokenError',
        'VAL_028': 'format',
        'VAL_008': 'tokenError',
        'RCP_001': 'recaptchaError',
        'STO_000': 'remoteError',
        'default': 'requestError',
    },
    trackError: {
        STA_001: 'odigeo',
        STA_006: 'facebook',
        STA_007: 'google',
        STA_008: 'social',
    },
    registerActions: {
        password: 'register',
        facebook: 'registerWithFacebook',
        google: 'registerWithGoogle',
    },
    email: null,
});
